/**
 * <s-expiring data-expires="YYYY-MM-DD"> removes itself once the shopper's
 * local date is past the given day. Liquid already skips expired content at
 * render time; this covers pages served from cache after the deadline.
 */
class SExpiring extends HTMLElement {
  connectedCallback() {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(this.dataset.expires ?? '');
    if (!match) return;
    const lastDay = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 23, 59, 59);
    if (Date.now() > lastDay.getTime()) this.remove();
  }
}

if (!customElements.get('s-expiring')) {
  customElements.define('s-expiring', SExpiring);
}
